import { Trans } from '@lingui/react/macro';
import { clsx } from 'clsx';

import Help from './Help/Help';
import styles from './SidePanel.module.css';
import SidePanelLoader from './SidePanelLoader';
import { useSignupParams } from '../../hooks/useSignupParams';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useGetBrandingQuery } from '../../lendingApi/lendingApiQueries';
import PoweredByIwoca from '../PoweredByIwoca/PoweredByIwoca';
import TrustPilot from '../TrustPilot/TrustPilot';

const SidePanel = () => {
  const { isMobile } = useWindowDimensions();
  const { isPartnerCustomer } = useSignupParams();

  const { branding, isBrandingLoading } = useGetBrandingQuery();

  const trustPilotTheme =
    branding?.data?.secondary_theme === 'light' ? 'light' : 'dark';

  const whiteIwocaLogo = Boolean(branding?.data?.iwoca_logo_colour === 'white');

  return (
    <div
      className={clsx(styles.container, {
        [styles.loading]: isPartnerCustomer && isBrandingLoading,
      })}
    >
      {isPartnerCustomer && isBrandingLoading ? (
        <SidePanelLoader />
      ) : (
        <>
          <div>
            <h2 className={styles.heading}>
              <Trans>Get fast, flexible funding on your terms</Trans>
            </h2>
            <div className={styles.completionSteps}>
              <h3 className={styles.stepsHeading}>
                <Trans>How does it work?</Trans>
              </h3>
              <ol className={styles.stepsList}>
                <li>
                  <Trans>Tell us about your business.</Trans>
                </li>
                <li>
                  <Trans>
                    Get a decision and receive multiple funding offers.
                  </Trans>
                </li>
                <li>
                  <Trans>
                    Once you accept an offer, you will receive funds within 24
                    hours.
                  </Trans>
                </li>
              </ol>
            </div>
            {!isMobile && <Help />}
          </div>
          {!isMobile && (
            <div className={styles.footer}>
              <PoweredByIwoca whiteLogo={whiteIwocaLogo} />
              <TrustPilot theme={trustPilotTheme} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SidePanel;
